import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControl } from '@mui/material';

import { SWATCH_COLORS } from './colors';
import InputGroup from './InputGroup';
import { StyledRadioGroup } from './styled';

const Swatches = ({ handleChange }) => {
  return (
    <FormControl variant="standard" component="fieldset">
      <StyledRadioGroup
        aria-label="button-style"
        name="button-style"
        defaultValue="thin"
        onChange={(e) => handleChange(e.target.value)}
      >
        {SWATCH_COLORS.map(({ id, color1, color2, color3 }) => (
          <Box display="flex" flexDirection="column" key={id}>
            <InputGroup color={color1} />
            <InputGroup color={color2} />
            <InputGroup color={color3} />
          </Box>
        ))}
      </StyledRadioGroup>
    </FormControl>
  );
};

Swatches.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default Swatches;
